import { render, staticRenderFns } from "./PaymentAdd.vue?vue&type=template&id=4734f87f&"
import script from "./PaymentAdd.vue?vue&type=script&lang=js&"
export * from "./PaymentAdd.vue?vue&type=script&lang=js&"
import style0 from "./PaymentAdd.vue?vue&type=style&index=0&id=4734f87f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports